/*!
 * BlocksView - Vue blocs hiérarchiques héritant de TreeView pour IconsView
 */

import TreeView from './TreeView';

export default class BlocksView extends TreeView {
    constructor(plugin) {
        super(plugin, 'blocks');
    }
}
